import LoadingModal from "../../components/LoadingModal/LoadingModal";
import { BNPLPaymentModal } from "../../components/payments/BNPLPaymentModal";
import { OfflinePaymentModal } from "../../components/payments/OfflinePaymentModal";
import PaymentInfoModal from "../../components/payments/PaymentInfoModal";
import PaymentModal from "../../components/payments/PaymentModal";
import { SuccessModal } from "../../components/SuccessModal";
import { ApplicableAdminFeeTypes } from "../../types/applicable-admin-fee.enum";
import { useContainer } from "./useContainer";

export default function PaymentLink() {
  const {
    showPaymentInfoModal,
    showPaymentModal,
    paymentInfo,
    paymentData,
    paymentMethod,
    loading,
    success,
    setShowPaymentModal,
    setShowPaymentInfoModal,
    control,
    setValue,
    getValues,
    requestPayment,
    sellerData,
    setAdminFee,
    paymentAttempts,
    setPaymentAttempts,
    bnplPayment,
    setBnplPayment,
    showPaymentOfflineModal,
    setShowPaymentOfflineModal,
  } = useContainer();
  return (
    <>
      <LoadingModal isLoading={loading} />

      {paymentMethod && showPaymentModal && (
        <PaymentModal
          setOpenPaymentModal={setShowPaymentModal}
          handleContinue={() => {
            if (getValues("paymentMethod") === "linkz-bnpl") {
              setPaymentAttempts((prev) => prev + 1);
              setBnplPayment(true);
              return;
            }
            if (getValues("paymentMethod") === "offline-payment") {
              setPaymentAttempts((prev) => prev + 1);
              setShowPaymentOfflineModal(true);
              return;
            }
            requestPayment();
          }}
          handleSkip={() => {
            setShowPaymentModal(false);
            window.close();
          }}
          open={showPaymentModal}
          control={control}
          setValue={setValue}
          paymentAmount={paymentData?.amount}
          paymentCurrency={paymentData?.currency}
          paymentMethods={paymentMethod}
          sellerId={paymentData?.sellerId}
          handleChangePaymentFee={setAdminFee}
          applicableAdminFee={
            (sellerData as any)?.applicableAdminFee ??
            ApplicableAdminFeeTypes.CHARGE_TO_SELLER
          }
          sellerCurrency={paymentData?.currency}
          isChargedPlatformFee={paymentData?.isChargedPlatformFee}
        />
      )}

      {paymentInfo && (
        <PaymentInfoModal
          open={showPaymentInfoModal}
          setOpenModal={setShowPaymentInfoModal}
          paymentInfo={paymentInfo}
          currency={paymentData?.currency}
          onFinish={() => window.close()}
          paymentAttempts={paymentAttempts}
          onChangePaymentMethod={() => setShowPaymentModal(true)}
        />
      )}

      <BNPLPaymentModal
        paymentAttempts={paymentAttempts}
        open={bnplPayment}
        setOpenModal={(open: boolean) => setBnplPayment(open)}
        onFinish={() => requestPayment()}
        onChangePaymentMethod={() => setShowPaymentModal(true)}
      />
      <OfflinePaymentModal
        open={showPaymentOfflineModal}
        paymentAttempts={paymentAttempts}
        onFinish={() => requestPayment()}
        setOpenModal={(open: boolean) => setShowPaymentOfflineModal(open)}
        onChangePaymentMethod={() => setShowPaymentModal(true)}
      />

      <SuccessModal
        open={success}
        title="Payment Successful"
        content="Thank you for your payment!"
      />
    </>
  );
}
